/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import { useSelector } from 'react-redux';
import { showRunStepsPanelSelector } from '../../../../services/ducks/designerDuck/designerDuck';
import { PANEL_PADDING, PANEL_WIDTH } from '../../../../utils/dimensions';
import { RunList } from './RunList';
import { RunSteps } from './RunSteps';
const runLogItemsContainerStyle = css`
  flex: 0 0 50%;
  overflow: hidden;
`;

export const RunLog = () => {
  const showRunStepsPanel = useSelector(showRunStepsPanelSelector);

  const runLogContainerStyle = css`
    display: flex;
    margin-left: ${showRunStepsPanel ? `-${PANEL_WIDTH}px` : '0px'};
    transition: margin-left ease 0.33s;
    width: 200%;
    column-gap: ${PANEL_PADDING}px;
  `;

  return (
    <div css={runLogContainerStyle}>
      <div css={runLogItemsContainerStyle}>
        <RunList />
      </div>
      <div css={runLogItemsContainerStyle}>
        <RunSteps />
      </div>
    </div>
  );
};
